export const addInstructorWizardText = {
  successMessage: 'Instructor Assigned Successfully',
  errorMessage: 'Failed to Assign Instructor',
  ModalTitle: 'Assign Instructor',
  currentInstructor: 'Current Instructor',
};
